import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    code: '',
    updated_id: '',
    is_no_records: '',
    lists: {},
    total_count: '',
    count: 1,
    updated_tag: '',
    list: {},
    filter_list: {},
    filter_name: '',
    Updatelist: {},
    search_criteria: '',
    message: {},
    error: '',
    details: '',
    items: {},
    serviceTotal: 0,
    tag_list: [],
    amc_pdt_list: [],
    Viewlist: {},
    log_details: {},
    export: {},
    sales_person_list: {},
    status_code: '',
    status_message: '',
    status_type: '',
    amccontract_index_history:'',
    index_status:''
}
const mutations = {
    SET_DATAS(state, lists) {
        state.error = ''
        state.lists = lists.amc_list
        state.total_count = lists.total_count
        state.count = lists.show
        state.search_criteria = lists.search
        state.is_no_records = lists.is_no_records
        state.filter_list = lists.filter_list
        state.filter_name = lists.filter_name
    },
    UPDATED_TAG(state, updated_id) {
        state.updated_tag = updated_id
    },
    LIST_DATA(state, list) {
        state.list = list
        state.error = ''
    },
    LIST_VIEW_DATA(state, list) {
        state.Viewlist = list
        state.error = ''
    },
    LIST_DETAILS(state, data) {

        state.tag_list = data.tag_list
        state.sales_person_list = data.sales_person_list
        state.amc_pdt_list = data.amc_product_list
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
        state.error = ''
    },
    STATUS_CODE(state, code) {
        state.code = code
    },
    CANCEL_STATUS(state, data) {
        state.message = data
        state.error = ''
    },
    TAG_LIST(state, data) {
        state.tag_list = data
    },
    LIST_SERVICE(state, data) {
        state.items = data.items
        state.serviceTotal = data.amc_total
        state.error = ''
    },
    LIST_LOG(state, data) {
        state.log_details = data
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },
}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {

        return AppService.amccontract.getamccontracts(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code != 404) {
                    commit("SET_CODE", response.data);
                    commit("SET_DATAS", response.data.data); // getting all the list in the api call
                  } else {
                    commit("SET_CODE", response.data);
                  }
                  return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {

        return AppService.amccontract.getamccontractExport(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchamccontractdetails({
        commit,
        rootState
    }) {
        return AppService.amccontract.getamccontractdetails(rootState.session.token)
            .then(response => {
                rootState.general.filterdetails = response.data
                commit('LIST_DETAILS', response.data) // getting all the list in the api call
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    createList({
        commit,
        rootState
    }, list) {

        return AppService.amccontract.postamccontract(list, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit('CANCEL_STATUS', response.data.data)
                    commit("SET_CODE", response.data);
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    addTag({
        commit,
        rootState
    }, tag_name) {
        return AppService.general.postTag(tag_name, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }   else if(response.status == 201) {
                    commit('UPDATED_TAG', response.data.updated_id)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }else {
                    commit('TAG_LIST', response.data.data) // getting all the list in the api call
                    commit('UPDATED_TAG', response.data.updated_id)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                  
                }
                return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {
        return AppService.amccontract.postamccontractUpdate(field, id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.status == 201) {
                    commit('CANCEL_STATUS', response.data.data)
                    commit("SET_CODE", response.data);
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchAmcContractList({
        commit,
        rootState
    },{
        id,
        page,
        type
    })  {

        return AppService.amccontract.getamccontract(id, page,type, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    displayavailableservice({
        commit,
        rootState
    }, id) {

        return AppService.amccontract.getamcservicelist(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('LIST_SERVICE', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateService({
        commit,
        rootState
    }, data) {

        return AppService.amccontract.postamccontractUpdateService(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    bulkdelete({
        commit,
        rootState
    }, id) {

        return AppService.amccontract.postAmcContractBulkDelete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_LOG', response.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deleteamccontract({
        commit,
        rootState
    }, data) {

        return AppService.amccontract.getAmcContractDelete(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },
    fetchAmcContractView({
        commit,
        rootState
    }, id) {

        return AppService.amccontract.getAmcContractView(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_VIEW_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filtercreateList({
        commit,
        rootState
    }, data) {

        return AppService.amccontract.postFiltercreateAmcContract(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },


    filterdelete({
        commit,
        rootState
    }, data) {

        return AppService.amccontract.postFilterdeleteAmcContract(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterupdateList({
        commit,
        rootState
    }, {
        id,
        data
    }) {

        return AppService.amccontract.postFilterudpateAmcContract(data, id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    /**
     * delete amc service individually
     * @param {*} param0 
     * @param {*} data 
     */
    deleteamccontractservice({
        commit,
        rootState
    }, data) {

        return AppService.amccontract.postservicedeleteAmcContract(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
}
export default {
    namespaced,
    state,
    mutations,
    actions
}